import { render } from "./organizations.vue?vue&type=template&id=55280f0e&scoped=true"
import script from "./organizations.vue?vue&type=script&lang=js"
export * from "./organizations.vue?vue&type=script&lang=js"

import "./organizations.vue?vue&type=style&index=0&id=55280f0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55280f0e"]])

export default __exports__